import { getExperiment, logEvent } from '@eventbrite/statsig';
import {
    FIRST_PAYOUT_METHOD_EXPERIMENT_CONTROL,
    FIRST_PAYOUT_METHOD_EXPERIMENT_MANDATORY,
    FIRST_PAYOUT_METHOD_EXPERIMENT_SKIPPABLE,
    PAYOUT_METHOD_EVENT_NAMES,
    REQUEST_FIRST_PAYOUT_METHOD_EXPERIMENT_NAME,
    REQUEST_FIRST_PAYOUT_METHOD_PARAMETER_NAME,
} from '../constants/statsig';

export const getFirstPayoutMethodExperimentVariant = () => {
    return getExperiment(
        REQUEST_FIRST_PAYOUT_METHOD_EXPERIMENT_NAME,
        REQUEST_FIRST_PAYOUT_METHOD_PARAMETER_NAME,
        FIRST_PAYOUT_METHOD_EXPERIMENT_CONTROL,
    );
};

export const shouldRedirectToBankAccountInformationPage = () => {
    const experimentVariant = getFirstPayoutMethodExperimentVariant();

    return (
        experimentVariant === FIRST_PAYOUT_METHOD_EXPERIMENT_MANDATORY ||
        experimentVariant === FIRST_PAYOUT_METHOD_EXPERIMENT_SKIPPABLE
    );
};

export const logPayoutMethodAddedEvent = () =>
    logEvent(PAYOUT_METHOD_EVENT_NAMES.ADD_NEW_PAYOUT_METHOD);

export const logFirstPayoutMethodExperimentPayoutMethodAddedEvent = () =>
    logEvent(
        PAYOUT_METHOD_EVENT_NAMES.FIRST_PAYOUT_METHOD_EXPERIMENT_ADD_NEW_PAYOUT_METHOD,
    );
